import Badge from "ds/components/Badge";
import Box from "ds/components/Box";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { showPreviewPermissionsDrawer } from "components/PreviewPermissions";

import { SpaceDetailsAccessRoleBindingBase } from "./types";

const SpaceDetailsAccessRoleCell = ({
  item: binding,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsAccessRoleBindingBase>) => {
  const { role } = binding;

  const handlePreviewPermissions = () => {
    showPreviewPermissionsDrawer({ roleId: role.id });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <Box align="center" gap="medium" fullWidth>
        <TableCellLink onPress={handlePreviewPermissions}>{role.name}</TableCellLink>
        {role.isSystem && <Badge type="strong" variant="blue" text="SYSTEM" />}
      </Box>
    </TableSimpleCell>
  );
};

export default SpaceDetailsAccessRoleCell;
